import React from 'react';
import AddCourseModal from '../components/AddCourseModal';
import CoursesList from '../components/CoursesList';
import LearningDashboard from '../components/LearningDashboard';

const CoursesPage: React.FC = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">My Courses</h1>
                <p className="text-gray-600">
                    Manage your courses and track your learning progress
                </p>
            </div>
            
            <LearningDashboard />
            
            <AddCourseModal />
            
            <div>
                <CoursesList />
            </div>
        </div>
    );
};

export default CoursesPage;